import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Header } from '../../shared/lib/ui/organisms/header';
import { Footer } from '../../shared/lib/ui/organisms/footer';
import { useTranslation } from 'react-i18next';
import useCabinet from '../../shared/lib/hooks/useCabinet';

export const MainPage = () => {
  const { t, i18n } = useTranslation();
  const { cabinet } = useCabinet();
  const { pathname } = useLocation();

  const notLandingPages = pathname !== '/advert' && pathname !== '/webmaster';

  useEffect(() => {
    const documentTitle = document.getElementById('browser-tab-title');
    const documentMetaDescription = document.getElementById('meta-description');

    if (documentTitle && documentMetaDescription && cabinet) {
      documentTitle.textContent = t(`seo.${cabinet}.title`);
      documentMetaDescription.textContent = t(`seo.${cabinet}.content`);
    }
  }, [i18n.resolvedLanguage, cabinet]);

  const navigate = useNavigate();
  useEffect(() => {
    if (pathname === '/') {
      navigate('/webmaster');
    }
  }, [pathname]);

  return (
    <>
      <Header hideElements={notLandingPages} />
      <main>
        <Outlet />
      </main>
      {notLandingPages === false && <Footer />}
    </>
  );
};
